import { createApi } from "@reduxjs/toolkit/query/react";
import { DocumentText } from "../../interfaces";
import { axiosBaseQuery } from "../axiosConfig";
import { RequestMethod } from "../enum";
import { transformDocumentText } from "./helper";
import { GetDocumentTextArgs } from "./types";

const getDocumentText = ({ id, workspaceId, flatten }: GetDocumentTextArgs): any => ({
  url: `/${id}/text`,
  method: RequestMethod.GET,
  params: { flatten },
  workspaceId,
});

export const documentApi = createApi({
  reducerPath: "documentApi",
  baseQuery: axiosBaseQuery<any>({
    baseUrl: "documents",
  }),
  endpoints: (build) => ({
    getDocumentText: build.query<DocumentText, GetDocumentTextArgs>({
      query: getDocumentText,
      transformResponse: (response: DocumentText) => transformDocumentText(response),
    }),
  }),
});
